module.exports = __webpack_public_path__ + "img/STORE_nanabozho.a5d44245.png";